import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

import {TableComponent} from '../../../../shared/components/table-component/table-component';
import {TitlePagesComponent} from '../../../../shared/components/title-pages-component/title-pages-component';


export interface Usuario {
  id: number;
  nombre: string;
  puesto: string;
  departamento: string;
  centroTrabajo: string;
  fechaIngreso: string;
  activo: boolean;
}
@Component({
  selector: 'app-edit-usuarios-component',
  standalone: true,
  imports: [
  ],
  templateUrl: './edit-usuarios-component.html',
  styleUrl: './edit-usuarios-component.scss',
})
export class EditUsuariosComponent {
  protected pageTitle = 'Editar usuario';
  protected showBtn: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router) {}

  editUsuario = (usuario: Usuario) => {
    this.router.navigate(['/usuarios/editar', usuario.id]);
  };

  columnDefinitions = [
    { key: 'nombre', displayName: 'Nombre' },
    { key: 'puesto', displayName: 'Puesto'},
    { key: 'departamento', displayName: 'Departamento' },
    { key: 'centroTrabajo', displayName: 'Centro de Trabajo' },
    { key: 'fechaIngreso', displayName: 'Fecha de Ingreso'},
    { key: 'acciones', displayName: 'Acciones' },
  ];

  // usuarios: Usuario[] = [] ;

  usuarios = [
    {
      id: 1,
      nombre: 'Laura Martínez',
      puesto: 'Analista de Datos',
      departamento: 'Inteligencia de Negocios',
      centroTrabajo: 'CDMX - Reforma',
      fechaIngreso: '2022-03-15',
      activo: true,
    },
    {
      id: 5,
      nombre: 'Carlos Gómez',
      puesto: 'Desarrollador Full Stack',
      departamento: 'Tecnología',
      centroTrabajo: 'Guadalajara - Tech Park',
      fechaIngreso: '2021-07-22',
      activo: true,
    },
    {
      id: 4,
      nombre: 'Ana Torres',
      puesto: 'Diseñadora UX/UI',
      departamento: 'Diseño',
      centroTrabajo: 'Monterrey - Oficinas Centrales',
      fechaIngreso: '2023-01-10',
      activo: true,
    },
    {
      id: 3,
      nombre: 'Jorge Ramírez',
      puesto: 'Gerente de Proyectos',
      departamento: 'PMO',
      centroTrabajo: 'CDMX - Insurgentes',
      fechaIngreso: '2020-10-05',
      activo: true,
    },
    {
      id: 2,
      nombre: 'María López',
      puesto: 'Especialista en Recursos Humanos',
      departamento: 'Capital Humano',
      centroTrabajo: 'Querétaro - Planta Norte',
      fechaIngreso: '2019-05-30',
      activo: true,
    },
    {
      id: 6,
      nombre: 'María Gutierrez',
      puesto: 'Recursos Humanos',
      departamento: 'Capital Humano',
      centroTrabajo: 'Querétaro - Planta Norte',
      fechaIngreso: '2019-05-30',
      activo: true,
    },
    {
      id: 7,
      nombre: 'Laura Martínez',
      puesto: 'Analista de Datos',
      departamento: 'Inteligencia de Negocios',
      centroTrabajo: 'CDMX - Reforma',
      fechaIngreso: '2022-03-15',
      activo: true,
    },
    {
      id: 8,
      nombre: 'Carlos Gómez',
      puesto: 'Desarrollador Full Stack',
      departamento: 'Tecnología',
      centroTrabajo: 'Guadalajara - Tech Park',
      fechaIngreso: '2021-07-22',
      activo: true,
    },
    {
      id: 9,
      nombre: 'Ana Torres',
      puesto: 'Diseñadora UX/UI',
      departamento: 'Diseño',
      centroTrabajo: 'Monterrey - Oficinas Centrales',
      fechaIngreso: '2023-01-10',
      activo: true,
    },
    {
      id: 10,
      nombre: 'Jorge Ramírez',
      puesto: 'Gerente de Proyectos',
      departamento: 'PMO',
      centroTrabajo: 'CDMX - Insurgentes',
      fechaIngreso: '2020-10-05',
      activo: true,
    },
    {
      id: 11,
      nombre: 'María López',
      puesto: 'Especialista en Recursos Humanos',
      departamento: 'Capital Humano',
      centroTrabajo: 'Querétaro - Planta Norte',
      fechaIngreso: '2019-05-30',
      activo: true,
    },
    {
      id: 12,
      nombre: 'María Gutierrez',
      puesto: 'Recursos Humanos',
      departamento: 'Capital Humano',
      centroTrabajo: 'Querétaro - Planta Norte',
      fechaIngreso: '2019-05-30',
      activo: true,
    },
  ];
}
